import { createContext, useContext } from "react";

export const modalControlsContextValue = {};

const ModalControlsContext = createContext({});
export const ModalControlsContextProvider = ModalControlsContext.Provider;
export const useModalControls = () => useContext(ModalControlsContext);
